import React from 'react';
import { business } from '../../data/site';
import { QuoteForm } from './QuoteForm';
export function QuoteSection() {
  return <section id="devis" aria-labelledby="quote-title" className="scroll-mt-20 bg-cream-dark" data-id="element-174" data-mp="2ehteqsh5bcdo">
      <div className="mx-auto grid max-w-7xl gap-14 px-5 py-24 md:px-8 md:py-28 lg:grid-cols-12" data-id="element-175" data-mp="20q51glv5uhv4">
        <div className="lg:col-span-4" data-id="element-176" data-mp="24r8kticf2w13">
          <h2 id="quote-title" className="font-serif text-4xl font-medium leading-tight text-forest md:text-5xl" data-id="element-177" data-mp="24o2xa7jfs27h">
            Demander un devis
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-ink-muted" data-id="element-178" data-mp="2xdt7i5hy6jyb">
            Gratuit et sans engagement. Je reviens vers vous pour convenir d’une visite.
          </p>
          <div className="mt-10 border-t border-line pt-6" data-id="element-179" data-mp="2odn1t5shqo9p">
            <p className="font-medium text-ink" data-id="element-180" data-mp="2og99d5fdt3rx">{business.name}</p>
            <address className="mt-2 not-italic leading-relaxed text-ink-muted" data-id="element-181" data-mp="17ylgawf06tqh">
              {business.street}
              <br data-id="element-182" data-mp="1d0kgxyjczcjq" />
              {business.postalCode} {business.city}
            </address>
          </div>
        </div>
        <div className="lg:col-span-8" data-id="element-183" data-mp="2ouvr3ymo20k0">
          <QuoteForm data-id="element-184" data-mp="2ovxg770ionkq" />
        </div>
      </div>
    </section>;
}